import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-success-conexa',
  templateUrl: './success-conexa.component.html',
  styleUrls: ['./success-conexa.component.scss']
})
export class SuccessConexaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
